import { CaretLeft, Check } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Divider } from "@tokenterminal/core/ui/layout/divider/Divider"
import ActionItem from "./ActionItem"

export const DEFAULT_NUMBER_FORMAT: NumberFormat = "compact"

type NumberFormatSwitcherProps = {
  handleBack: () => void
  numberFormat: NumberFormat
  setNumberFormat: (format: NumberFormat) => void
}

export const numberFormatOptions = [
  {
    id: "compact",
    label: "Compact",
    sublabel: "1M",
  },
  {
    id: "consistent",
    label: "Consistent",
    sublabel: "1,000 K",
  },
  {
    id: "full",
    label: "Full",
    sublabel: "1,000,000",
  },
] as const

export type NumberFormat = (typeof numberFormatOptions)[number]["id"]
export const isNumberFormat = (format: string): format is NumberFormat => {
  return numberFormatOptions.some((option) => option.id === format)
}

const NumberFormatSwitcher = ({
  handleBack,
  numberFormat,
  setNumberFormat,
}: NumberFormatSwitcherProps) => {
  return (
    <div className="flex flex-col p-2 gap-2">
      <div className="flex flex-col gap-2">
        <Button
          onPress={handleBack}
          variant="ghost"
          size="small"
          className="self-start !text-xs !p-2 !rounded-[6px]"
        >
          <Icon as={CaretLeft} />
          Back
        </Button>
        <div className="flex flex-col items-start pl-2">
          <div className="text-sm font-medium">Formatting</div>
          <div className="text-xs text-fg-secondary">
            Adjust how numbers are displayed
          </div>
        </div>
      </div>
      <Divider variant="secondary" className="-mx-2" />
      <div
        className="flex flex-col gap-0 with-overflow"
        style={{
          // Hardcoded to cut off at 7.5 items
          maxHeight: "322px",
        }}
      >
        {numberFormatOptions.map((option) => (
          <ActionItem
            key={option.id}
            item={{
              label: (
                <div className="flex flex-col gap-0 max-w-full w-full">
                  {option.label}
                  <div className="text-xs text-fg-secondary font-mono">
                    {option.sublabel}
                  </div>
                </div>
              ),
              onClick: () => {
                setNumberFormat(option.id)
              },
              icon: option.id === numberFormat ? Check : undefined,
              style: {
                padding: "8px 10px",
              },
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default NumberFormatSwitcher
